var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientsPricing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 80,
    viewBox: "0 0 130 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.1473 46.2377C74.7473 46.2377 58.9588 61.3725 58.8918 80H63.6179H69.4314H88.3021L88.3224 69.4453H72.1978C76.3107 61.9426 84.594 56.7924 94.1473 56.7924C103.701 56.7924 111.984 61.9426 116.097 69.4453H100.03L100.009 80H118.864H119.812H129.403C129.336 61.3725 113.548 46.2377 94.1473 46.2377Z",
    fill: "#587E85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5523 39.396C19.3039 39.396 0.411645 57.6385 0.598047 79.9927C0.601008 79.9957 0.602666 79.9973 0.605627 80H4.72282H11.1421H36.701L36.7214 69.4453H13.0482C17.4634 58.0802 29.0229 49.9507 42.5523 49.9507C56.0818 49.9507 67.6413 58.0802 72.0565 69.4453H48.4285L48.4079 80H73.9625H81.9893H84.4989C84.5018 79.9973 84.5036 79.9957 84.5064 79.9927C84.693 57.6385 65.8008 39.396 42.5523 39.396Z",
    fill: "#587E85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8976 49.9518C28.5709 49.9518 16.915 38.7477 16.915 24.9759C16.915 11.2041 28.5708 0 42.8976 0C57.2243 0 68.8801 11.2041 68.8801 24.9759C68.8801 38.7477 57.2242 49.9518 42.8976 49.9518ZM42.8976 10.5547C34.3906 10.5547 27.4698 17.0237 27.4698 24.9759C27.4698 32.928 34.3906 39.397 42.8976 39.397C51.4046 39.397 58.3254 32.928 58.3254 24.9759C58.3254 17.0237 51.4046 10.5547 42.8976 10.5547Z",
    fill: "#A9CF3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4018 56.793C83.1589 56.793 73.1986 47.202 73.1986 35.4133C73.1986 23.6245 83.1589 14.0335 95.4018 14.0335C107.644 14.0335 117.604 23.6245 117.604 35.4133C117.605 47.202 107.644 56.793 95.4018 56.793ZM95.4018 24.5882C88.9786 24.5882 83.7533 29.4442 83.7533 35.4133C83.7533 41.3823 88.9786 46.2383 95.4018 46.2383C101.824 46.2383 107.05 41.3823 107.05 35.4133C107.05 29.4442 101.825 24.5882 95.4018 24.5882Z",
    fill: "#A9CF3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientsPricing);
export default __webpack_public_path__ + "static/media/patients-pricing.e56c8db2d6e95ed2dec130e49cae70e7.svg";
export { ForwardRef as ReactComponent };